module.exports = __webpack_public_path__ + "static/media/blog-4.9eb35f16.svg";